import { createContext, useContext, useState, ReactNode } from 'react';
import LuxurySearchModal from '@/components/LuxurySearchModal';

type SearchModalContextType = {
  openSearch: () => void;
  closeSearch: () => void;
};

export const SearchModalContext = createContext<SearchModalContextType | undefined>(undefined);

export const useSearchModal = () => {
  const context = useContext(SearchModalContext);
  if (!context) {
    throw new Error('useSearchModal must be used within SearchModalProvider');
  }
  return context;
};

export const SearchModalProvider = ({ children }: { children: ReactNode }) => {
  const [searchOpen, setSearchOpen] = useState(false);

  const openSearch = () => setSearchOpen(true);
  const closeSearch = () => setSearchOpen(false);

  return (
    <SearchModalContext.Provider value={{ openSearch, closeSearch }}>
      {children}
      <LuxurySearchModal open={searchOpen} onOpenChange={setSearchOpen} />
    </SearchModalContext.Provider>
  );
};
